import React, { useState } from 'react';
import { translate } from '../../services/translate';
import MyDropDownPicker from '../../components/MyDropDownPicker';
import { MyCheckbox } from '../../components/MyCheckbox';
import BasicModal from '../../components/BasicModal';
import { View } from 'react-native';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: (videoStorageProviderId: number, useGPFileTransfer: boolean) => Promise<void>;
    availableVideoStorageProviders: { id: number; name: string; }[];
}

export default function UpdateVideoStorageProviderModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    availableVideoStorageProviders,
}: ModalProps) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [videoStorageProviderId, setVideoStorageProviderId] = useState<number | null>(null);
    const [useGPFileTransfer, setUseGPFileTransfer] = useState<boolean>(false);

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('selectVideoStorageProvider')}
            width='small'
            mobileHeight='fill'
            primaryButton={{
                text: translate('confirm'),
                onClick: async () => {
                    if (!videoStorageProviderId) {
                        return;
                    }
                    await onSubmit(videoStorageProviderId, useGPFileTransfer);
                },
                disabled: !videoStorageProviderId,
            }}
            disableScrollView={true}
        >
            <View style={{ flex: 1, gap: 8, zIndex: 3 }}>
                <MyDropDownPicker
                    placeholder={translate('videoStorageProviders')}
                    searchable={true}
                    items={[{}, ...availableVideoStorageProviders.map(p => ({
                        value: p.id,
                        label: p.name,
                    }))]}
                    open={dropdownOpen}
                    setOpen={setDropdownOpen}
                    setValue={setVideoStorageProviderId}
                    value={videoStorageProviderId}
                    zIndex={3}
                />
                <View style={{ height: 40 }}>
                    <MyCheckbox
                        label={translate('useTransferFile')}
                        checked={useGPFileTransfer}
                        setChecked={setUseGPFileTransfer}
                    />
                </View>
            </View>
        </BasicModal>
    );
}
